<template>
  <div class="shop-order-buyer-section">
    <section class="order-card">
      <div class="section-title">买家信息</div>
      <div class="form-grid">
        <div v-if="showBuyerFieldFn('first_name')" class="form-item">
          <label>买家名<span class="required">*</span></label>
          <el-input v-model.trim="booking.buyer_first_name" placeholder="请输入买家名"></el-input>
        </div>
        <div v-if="showBuyerFieldFn('last_name')" class="form-item">
          <label>买家姓<span class="required">*</span></label>
          <el-input v-model.trim="booking.buyer_last_name" placeholder="请输入买家姓"></el-input>
        </div>
        <div v-if="showBuyerFieldFn('tel')" class="form-item">
          <label>联系电话<span class="required">*</span></label>
          <el-input v-model.trim="booking.buyer_tel_number" placeholder="请输入电话号码"></el-input>
        </div>
        <div v-if="showBuyerFieldFn('email')" class="form-item">
          <label>邮箱<span class="required">*</span></label>
          <el-input v-model.trim="booking.buyer_Email" placeholder="请输入邮箱"></el-input>
        </div>
      </div>
    </section>

    <section v-if="showGuideLang" class="order-card">
      <div class="section-title">导游语言</div>
      <div class="form-grid">
        <div class="form-item">
          <label>导游语言<span class="required">*</span></label>
          <el-select v-model="booking.guide_lang" filterable placeholder="请选择导游语言">
            <el-option
              v-for="item in getFieldOptionsFn(bookingField.guide_lang, 'guide_lang')"
              :key="'lang-' + getOptionValueFn(item)"
              :label="getOptionLabelFn(item)"
              :value="getOptionValueFn(item)"
            />
          </el-select>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ShopOrderBuyerSection',
  props: {
    booking: { type: Object, required: true },
    bookingField: { type: Object, required: true },
    showGuideLang: { type: Boolean, default: false },
    showBuyerFieldFn: { type: Function, required: true },
    getFieldOptionsFn: { type: Function, required: true },
    getOptionLabelFn: { type: Function, required: true },
    getOptionValueFn: { type: Function, required: true },
  },
};
</script>

<style scoped>
@import './shopOrderSection.css';
</style>



// WEBPACK FOOTER //
// src/pages/shop/components/ShopOrderBuyerSection.vue